import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '../../tms-shared';

@Injectable({
  providedIn: 'root',
})
export class LogoutService extends BaseService {
  constructor() {
    super('Identity/Logout');
  }

  logout(): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/Logout`, undefined);
  }
}
